import { Box, Button, List, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import { getMessageFromError } from '@pro4-erp/core-web';
import { FileItem, SqoFile } from '@/common';
import { downloadCertificateFromDws } from '@/features/client-certificates/api/downloadFileFromCertificate';
import { useState } from 'react';
import ClientAnswerModal from './ClientAnswerModal';

type AnswersProps = {
  answers?: SqoFile[];
  hasRecomendations?: boolean;
  hasNonConform?: boolean;
  visitId: string;
};

const Answers = ({ answers, hasRecomendations, hasNonConform, visitId }: AnswersProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [answerType, setAnswerType] = useState<'rec' | 'nonConf' | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const downloadFileMutation = useMutation({
    mutationFn: downloadCertificateFromDws,
    onSuccess: async () => {
      enqueueSnackbar(
        t('Successfully downloaded file.', { defaultValue: 'Successfully downloaded file.' }),
        { variant: 'success' }
      );
    },
    onError: (error: Error) => {
      enqueueSnackbar(getMessageFromError(error), { variant: 'error' });
    },
  });

  return (
    <Box>
      <ClientAnswerModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        visitId={visitId}
        answerType={answerType}
      />
      {hasRecomendations && (
        <Button
          onClick={() => {
            setAnswerType('rec');
            setIsModalOpen(true);
          }}
        >
          {t('Add a answer on recomendations', {
            defaultValue: 'Add a answer on recomendations',
          })}
        </Button>
      )}
      {hasNonConform && (
        <Button
          onClick={() => {
            setAnswerType('nonConf');
            setIsModalOpen(true);
          }}
        >
          {t('Add a answer on noncompliances', {
            defaultValue: 'Add a answer on noncompliances',
          })}
        </Button>
      )}
      {answers && answers.length > 0 ? (
        <List>
          {answers.map((item) => (
            <FileItem
              key={item.id}
              name={item.title || ''}
              uploadedBy={item.uploadedBy}
              uploadedAt={item.uploadedAt}
              fileName={item.fileName}
              info={item.info}
              onDownload={() => {
                if (item.dwsDok)
                  downloadFileMutation.mutate({
                    dok: item.dwsDok,
                    filename: item.title || item.dwsDok.originalfilename,
                  });
              }}
            />
          ))}
        </List>
      ) : (
        <Typography variant="subtitle1">{t('No files', { defaultValue: 'No files' })}</Typography>
      )}
    </Box>
  );
};

export default Answers;
